import { useQuery } from 'react-query'

import { getSitePaymentGatewayOnboardingStatus } from '_services/payment-gateway.service'

interface OnboardingStatusInfo {
  onboardingStatus: string | null
  requiresAttention: boolean
  hasEventuallyDueRequirements: boolean
}

interface QueryResponse {
  site: {
    paymentGatewayOnboardingStatus: OnboardingStatusInfo | null
  } | null
}

export const usePaymentGatewayOnboardingStatus = (siteId?: string) => {
  return useQuery<QueryResponse, Error, OnboardingStatusInfo | null | undefined>(
    [getSitePaymentGatewayOnboardingStatus.key, { siteId }],
    () =>
      getSitePaymentGatewayOnboardingStatus.query({
        pageParam: { siteId },
      }) as Promise<QueryResponse>,
    {
      select: (data) => data?.site?.paymentGatewayOnboardingStatus,
      enabled: !!siteId,
    }
  )
}
